"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTransport = exports.IframeTransport = void 0;
var fbemitter_1 = require("fbemitter");
var getEventData = function (event) {
    return event.data;
};
var IframeTransport = /** @class */ (function () {
    function IframeTransport(targetFrame, options) {
        var _this = this;
        this.targetFrame = targetFrame;
        this.options = options;
        this.messagesEmitter = new fbemitter_1.EventEmitter();
        this.handleMessage = function (event) {
            if (!_this.getTargetOrigin().includes(event.origin)) {
                return;
            }
            var _a = getEventData(event), type = _a.type, data = _a.data;
            _this.messagesEmitter.emit(type, data);
        };
        window.addEventListener('message', this.handleMessage);
    }
    IframeTransport.prototype.getTargetOrigin = function () {
        return this.options.targetOrigin;
    };
    IframeTransport.prototype.destroy = function () {
        this.messagesEmitter.removeAllListeners();
        window.removeEventListener('message', this.handleMessage);
    };
    IframeTransport.prototype.sendMessage = function (message) {
        var contentWindow = this.targetFrame.contentWindow;
        if (!contentWindow) {
            throw Error("can not send message \"" + JSON.stringify(message) + "\", no contentWindow");
        }
        contentWindow.postMessage(message, this.getTargetOrigin());
    };
    IframeTransport.prototype.waitForMessage = function (postMessageType) {
        var _this = this;
        return new Promise(function (resolve) {
            _this.messagesEmitter.once(postMessageType, function (data) {
                resolve(data);
            });
        });
    };
    IframeTransport.prototype.addListener = function (postMessageType, listener) {
        this.messagesEmitter.addListener(postMessageType, listener);
    };
    return IframeTransport;
}());
exports.IframeTransport = IframeTransport;
exports.createTransport = function (targetFrame, options) {
    return new IframeTransport(targetFrame, options);
};
//# sourceMappingURL=iframe-transport.js.map